import api from '@/api/sales'

const getDefaultState = () => {
  return {
    id: 0,
    // subtotal: 0.0,
    // total: 0.0,
    // formattedTotal: 0.0,
    // We can get this from commissions store?
    commissionType: 'national',
    commissionAmount: 0.0,
    status: '',
    contractTag: '',
    contractType: '',
    // We can get this from products store?
    productName: '',
    productPrice: 0.0,
    validToProcess: false,
    rationale: '',
    processed: false,
    invoiceableSales: [],
    selectedSales: new Set(),
    selectedPaymentMethod: '',
    selectedStall: ''
  }
}

const state = getDefaultState()

const mutations = {
  SET_SALE: (state, data) => {
    state.id = data.id
    state.subtotal = data.subtotal
    state.total = data.total
    state.formattedTotal = data.formatted_total
    state.commissionType = data.commission_type
    state.commissionAmount = data.commission_amount
    state.status = data.status
    state.contractTag = data.contract_tag
    state.contractType = data.contract_type
    state.productName = data.product_name
    state.productPrice = data.product_price
    state.validToProcess = data.valid_to_process
    state.rationale = data.last_attempt_status
  },
  ALREADY_PROCESSED: (state, value) => {
    state.processed = value
  },
  ERROR_ON_SALE: (state, rationale) => {
    state.validToProcess = false
    state.rationale = rationale
  },
  SET_SALES: (state, list) => {
    state.invoiceableSales = list
  },
  SELECT_FIRST_SALE: (state, sale) => {
    state.selectedSales = new Set([...state.selectedSales]).add(sale.id)
    state.selectedPaymentMethod = sale.payment_method
    state.selectedStall = sale.stall
  },
  SET_STATUS: (state, status) => {
    state.status = status
  },
  SELECT_SALE: (state, id) => {
    state.selectedSales = new Set([...state.selectedSales]).add(id)
  },
  DESELECT_SALE: (state, saleId) => {
    state.selectedSales = new Set([...state.selectedSales].filter(id => id !== saleId))
  },
  DESELECT_LAST_SALE: (state, sale) => {
    state.selectedSales = new Set([...state.selectedSales].filter(id => id !== sale.id))
    state.selectedPaymentMethod = ''
    state.selectedStall = ''
  },
  CLEAR_SELECTED_SALES: (state) => {
    state.selectedSales = new Set()
    state.selectedPaymentMethod = ''
    state.selectedStall = ''
  }
}

const actions = {
  async getSale ({ commit, state }, id) {
    try {
      const { data } = await api.getSale(id)
      commit('SET_SALE', data)
      commit('vehicles/SET_CURRENT_VEHICLE', data.vehicle_id, { root: true })
      commit('payments/SET_CARD_NUMBER', data.card_info.number, { root: true })
      commit('payments/SET_CARD_EXPIRATION_MONTH', data.card_info.expiration.substring(0, 2), { root: true })
      commit('payments/SET_CARD_EXPIRATION_YEAR', data.card_info.expiration.substring(3), { root: true })
    } catch (error) {
      commit('ERROR_ON_SALE', `Ocurrio un error al procesar el pago ${state.id}; Reportalo a la línea express`)
      commit('payments/SET_CARD_NUMBER', '', { root: true })
      commit('payments/SET_CARD_EXPIRATION_MONTH', '', { root: true })
      commit('payments/SET_CARD_EXPIRATION_YEAR', '', { root: true })
    }
  },
  async getSales ({ commit }) {
    commit('app/START_LOADING', '', { root: true })
    try {
      const { data } = await api.getSales()
      commit('SET_SALES', data)
      commit('app/FINISH_LOADING', '', { root: true })
    } catch (error) {
      commit('app/FINISH_LOADING', '', { root: true })
    }
  },
  selectSale ({ commit, state }, saleId) {
    const sale = state.invoiceableSales.find(sale => parseInt(sale.id) === parseInt(saleId))
    if (state.selectedSales.size < 1) {
      commit('SELECT_FIRST_SALE', sale)
    } else {
      const isSameMethod = (sale.payment_method === state.selectedPaymentMethod)
      const isSameStall = (sale.stall === state.selectedStall)
      if (isSameMethod && isSameStall) {
        commit('SELECT_SALE', sale.id)
      }
    }
  },
  deselectSale ({ commit, state }, saleId) {
    const sale = state.invoiceableSales.find(sale => parseInt(sale.id) === parseInt(saleId))
    if (state.selectedSales.size <= 1) {
      commit('DESELECT_LAST_SALE', sale)
    } else {
      commit('DESELECT_SALE', sale.id)
    }
  }
}

const getters = {
  id: state => state.id,
  saleOrderProcessed: state => state.processed,
  selectedSales: state => state.selectedSales,
  invoiceableSales: state => state.invoiceableSales,
  atLeastOnSelectedSale: state => state.selectedSales.size > 0
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
